import { AuthAction, AuthState } from './types';

import { login, logout } from '../../actions/auth';

/**
 * @name state.auth
 * @type {{processing: boolean, error: (string|null), isSuccess: boolean}}
 */

export const initialState: AuthState = {
  processing: false,
  error: null,
  isLoginSuccess: false,
  isLogoutSuccess: false,
};

export default (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case login.pending.toString():
      return {
        ...initialState,
        processing: true,
        error: null,
      };

    case login.fulfilled.toString():
      return {
        ...initialState,
        isLoginSuccess: true,
      };

    case logout.fulfilled.toString():
      return {
        ...initialState,
        isLogoutSuccess: true,
      };

    case login.rejected.toString():
      return {
        ...initialState,
        processing: false,
        error: action.payload?.message || action.error?.message || null,
      };

    default:
      return state;
  }
};
